import React, { useState } from 'react'
import { Form, Input, Button } from 'semantic-ui-react'

const EmailAuth = ({ onSubmit, submit }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })
  const setFormField = (name, value) =>
    setFormData(d => ({
      ...d,
      [name]: value,
    }))

  const [formErrors, setFormErrors] = useState({
    email: null,
    password: null,
  })
  const setFormError = (name, err) =>
    setFormErrors(d => ({
      ...d,
      [name]: err,
    }))

  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async () => {
    setSubmitting(true)
    setFormErrors({
      email: null,
      password: null,
    })

    try {
      await onSubmit(formData)
    } catch (err) {
      setFormError(err.field, err.message)
    }

    setSubmitting(false)
  }

  return (
    <Form size="large" onSubmit={handleSubmit} loading={submitting}>
      <Form.Field
        id="email"
        control={Input}
        type="email"
        iconPosition="left"
        icon="at"
        label="Email"
        error={formErrors.email}
        onChange={evt => {
          setFormField('email', evt.target.value)
        }}
      />

      <Form.Field
        id="password"
        control={Input}
        type="password"
        iconPosition="left"
        icon="lock"
        label="Password"
        error={formErrors.password}
        onChange={evt => {
          setFormField('password', evt.target.value)
        }}
      />

      <Button type="submit" primary size="huge">
        {submit}
      </Button>
    </Form>
  )
}

export default EmailAuth
